import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';

import { downloadExcel, downloadSettingExcel } from "src/utils/blob/blobUtil";

import useFetchActionbarAuth from 'src/hooks/useFetchActionbarAuth';
import useUiuxStore, { Tab } from 'src/store/useUiuxStore';
import { useLoadingSpinnerStore } from 'src/store/util/loadingSpinnerUtil';
import { showError, showSuccess, ShowSuccessFetch, showWarning } from 'src/utils/toast/toastUtil';

import { createWMS1131_R01LotNo, deleteWMS1131_R01, downloadExcel_WMS1131_R01, getPdfBlob_WMS1131_R01, getWMS1131_R01AllCount, getWMS1131_R01DetailList, getWMS1131_R01List, getWMS1131_R01One, postWMS1131_R01 } from "./Api_WMS1131_R01";
import { defaultWMS1131_R01DetailDto, defaultWMS1131_R01HeaderDto, WMS1131_R01DetailDto, WMS1131_R01Dto, WMS1131_R01HeaderDto } from './Dto_WMS1131_R01';
import { AgGridReact } from 'ag-grid-react';
import { fetchDataSetHandler, fetchFilterConfig, gridRefSelectedRowHandler, InsertRowHandler } from 'src/utils/grid/GridHandlerContent';
import { useCommonCodeStore } from 'src/store/useCommonCodeStore';
import { validateString } from 'src/utils/string/stringUtil';
import { validateCustomCd, validateEmployeeCd } from 'src/utils/grid/GridValidateContent';
import { useCommonCodeValidate } from 'src/utils/commonCode/CommonCodeValidateContext';
import {
	buildCommonCodeRequirements,
	WMS1131_R01_DETAIL_ROW_VALIDATE,
	WMS1131_R01_HEADER_ROW_VALIDATE,
} from 'src/utils/commonCode/commonCodeRequirementConfig';
import { useWMS1131_R01Store, WMS1131_R01Filter } from './Store_WMS1131_R01';
import { WMS1131_R01_extractUnprintedItemLabelData } from './labelDataBuilder_WMS1131_R01';
import { useQzPrint } from 'src/hooks/useQzPrint';
import { useItemQzPrint } from 'src/hooks/useItemQzPrint';
import { ItemLabelPrintData } from 'src/apis/itemLabelApi';
import { getDefaultLabelPrintAuto } from 'src/utils/label/labelPrintAutoProgramUtil';
import qz from 'qz-tray';

interface Props {
	gridRef: React.RefObject<AgGridReact<WMS1131_R01HeaderDto> | null>;
	detailGridRef: React.RefObject<AgGridReact<WMS1131_R01DetailDto> | null>;

	tabList: Tab[] | undefined;
	setMessage: (message: string) => void;
	
	containerRef: React.RefObject<HTMLDivElement | null>;
	isResizing: React.MutableRefObject<boolean>;
	
}



export const Content_WMS1131_R01 = (props: Props) => {

	const {
		gridRef, detailGridRef,
		tabList, setMessage,
		containerRef,
		isResizing,
	} = props;

	const { vatTypeList, moneyCdList, itemStatusList, inoutClassList, inoutMethodList, inoutTypeList, wmsCdList, compCdList, customCdList, employeeCdList, warehouseCdList, programList } = useCommonCodeStore();

	const defaultLabelPrintAuto = useMemo(
		() => getDefaultLabelPrintAuto(programList),
		[programList]
	);
	const {
		WMS1131_R01Filter, setWMS1131_R01Filter,
		WMS1131_R01PastFilter, setWMS1131_R01PastFilter,
		WMS1131_R01List, setWMS1131_R01List,
		editWMS1131_R01, setEditWMS1131_R01,
		deletedWMS1131_R01DetailList, setDeletedWMS1131_R01DetailList, addDeletedWMS1131_R01DetailList, removeDeletedWMS1131_R01DetailList,
		WMS1131_R01DetailList, setWMS1131_R01DetailList, insertWMS1131_R01DetailList,
		selectedWMS1131_R01, setSelectedWMS1131_R01, initSelectedWMS1131_R01,
		selectedWMS1131_R01DetailList, setSelectedWMS1131_R01DetailList, addSelectedWMS1131_R01DetailList, removeSelectedWMS1131_R01DetailList, initSelectedWMS1131_R01DetailList,
		originalWMS1131_R01DetailList, setOriginalWMS1131_R01DetailList,
		allCount, setAllCount,
		detailFetchTrigger, setDetailFetchTrigger,
		initData, 
		setScrollTop,
		setDetailScrollTop,
	} = useWMS1131_R01Store();
	const { PUR1020_WMS1131NavigationData, setPUR1020_WMS1131NavigationData, PUR1021_WMS1131NavigationData, setPUR1021_WMS1131NavigationData } = useUiuxStore();
	const { setLoadingSpinner } = useLoadingSpinnerStore();
	const { validateCommonCodeLists } = useCommonCodeValidate();
	const { printPdfFromBlob } = useQzPrint();
	const { printBulkItemLabel } = useItemQzPrint();

	useFetchActionbarAuth("WMS1131_R01");

	const [clickable, setClickable] = useState(true);

	const prevWmsOrderNoRef = useRef<string | undefined>(undefined);

	const handlePrintClick = useCallback(async () => {
		if (!editWMS1131_R01 || !editWMS1131_R01.transportNo) {
				showWarning("출력할 수불번호를 선택하세요.");
				setMessage("출력할 수불번호를 선택하세요.");
				return;
		}
		setLoadingSpinner(true);
		try {
			const blob = await getPdfBlob_WMS1131_R01(editWMS1131_R01.transportNo);
			if (qz.websocket.isActive()) {
				const ok = await printPdfFromBlob(blob, "report1");
				if (ok) {
					showSuccess("PDF 출력을 완료하였습니다.");
				} else {
					const fileURL = URL.createObjectURL(blob);
					window.open(fileURL, "_blank");
					setTimeout(() => URL.revokeObjectURL(fileURL), 5000);
				}
			} else {
				const fileURL = URL.createObjectURL(blob);
				window.open(fileURL, "_blank");
				setTimeout(() => URL.revokeObjectURL(fileURL), 5000);
				showSuccess("PDF를 새 탭에서 열었습니다.");
			}
		} catch (error) {
			setMessage("PDF 출력 중 오류가 발생했습니다.");
		} finally {
			setLoadingSpinner(false);
		}
	}, [editWMS1131_R01, printPdfFromBlob, setLoadingSpinner, setMessage]);
	

	const handleExcelClick = useCallback(async () => {
		if (!editWMS1131_R01) {
			showWarning("선택된 수불내역이 없습니다.");
			return;
		}
		setLoadingSpinner(true);

		const response = await downloadExcel_WMS1131_R01('', editWMS1131_R01.transportNo, WMS1131_R01DetailList.length ?? 0);

		downloadSettingExcel({ responseData: response.data.data, fileName: '수불전표 등록-excel.xlsx' });

		setLoadingSpinner(false);
	}, [editWMS1131_R01]);
	
	const getParams = (filter: WMS1131_R01Filter) => {
		const params: Partial<WMS1131_R01Filter> = {
			dateRange: filter.dateRange || undefined,
			wmsOrderNo: filter.wmsOrderNo || undefined,
			customCd: filter.customCd || undefined,
		};
		return params;
	}

	const renewalAllCount = useCallback(async () => {
		const response = await getWMS1131_R01AllCount(getParams(WMS1131_R01Filter));
		setAllCount(response.data.data);
		return response.data.data;
	}, [WMS1131_R01Filter, setAllCount]);

	const fetchData = useCallback(async (skipSelection?: boolean) => {
		setLoadingSpinner(true);
		setScrollTop(null);
		setDetailScrollTop(null);
	
		const responseData = (await getWMS1131_R01List(
			'',
			getParams(WMS1131_R01Filter),
			WMS1131_R01List.length ?? 0
		));

		let newList = [...responseData.data.data ] as WMS1131_R01HeaderDto[];
		setWMS1131_R01List(newList);

		const processAllCount = await renewalAllCount();
		if (newList && newList.length > 0) {
			if (skipSelection !== true) {
				gridRefSelectedRowHandler(
					gridRef,
					setSelectedWMS1131_R01,
					() => true,
				);
			}
			setWMS1131_R01PastFilter(WMS1131_R01Filter);
			ShowSuccessFetch(setMessage, `조회가 완료되었습니다. (총 ${newList.length}/${processAllCount}건)`);
			setTimeout(() => setMessage(""), 5000);
		}else {
			showWarning('데이터가 없습니다.');
			handleCreateClick();
		}
		setLoadingSpinner(false);
		return responseData;
	}, [WMS1131_R01Filter, WMS1131_R01List, setWMS1131_R01List, setWMS1131_R01PastFilter, setSelectedWMS1131_R01, selectedWMS1131_R01, setScrollTop, setDetailScrollTop])

	const fetchOne = useCallback(async () => {
		if (!selectedWMS1131_R01) return;

		const response = await getWMS1131_R01One(selectedWMS1131_R01.transportNo);

		return response.data.data as WMS1131_R01HeaderDto;
	}, [selectedWMS1131_R01]);

	const defaultWMS1131_R01HeaderRow = useCallback(() => {
		const logicCenter = editWMS1131_R01?.logicCenter || wmsCdList[0]?.minorCd || '';
		const warehouseCdListToUse = warehouseCdList.filter(value =>
			value.logicCenter === logicCenter && value.materialYn === 'Y'
		);
		const inoutClassListToUse = inoutClassList.filter(item => item.minorCd === '170');

		const commonResult = validateCommonCodeLists(
			buildCommonCodeRequirements(WMS1131_R01_HEADER_ROW_VALIDATE, {
				compCdList,
				inoutClassList: inoutClassListToUse,
				inoutMethodList,
				wmsCdList,
				warehouseCdList: warehouseCdListToUse,
				inoutTypeList,
			}),
		);
		if (!commonResult.valid) {
			return { ...defaultWMS1131_R01HeaderDto };
		}

		return {
			...defaultWMS1131_R01HeaderDto,
			compCd: compCdList[0].compCd,
			inoutMethod: inoutMethodList[0].minorCd,
			logicCenter,
			warehouseCd: warehouseCdListToUse[0].warehouseCd,
			inoutType: inoutTypeList.find(value => value.minorCd === 'IN')?.minorCd || '',
			inoutClass: inoutClassListToUse.find(value => value.minorCd === '170')?.minorCd || '',
		};
	}, [
		editWMS1131_R01, defaultWMS1131_R01HeaderDto, compCdList, wmsCdList, warehouseCdList,
		inoutMethodList, inoutClassList, inoutTypeList, validateCommonCodeLists,
	]);

	const defaultWMS1131_R01DetailRow = useCallback(() => {
		const commonResult = validateCommonCodeLists(
			buildCommonCodeRequirements(WMS1131_R01_DETAIL_ROW_VALIDATE, {
				itemStatusList,
			}),
		);
		if (!commonResult.valid) {
			return { ...defaultWMS1131_R01DetailDto };
		}

		return {
			...defaultWMS1131_R01DetailDto,
			itemStatus: itemStatusList[0].minorCd,
			printed: false,
			inserted: true,
		};
	}, [defaultWMS1131_R01DetailDto, itemStatusList, validateCommonCodeLists]);
	
	const initContainerData = useCallback(() => {
		initData();
		setWMS1131_R01Filter({ labelPrintAuto: defaultLabelPrintAuto });
		removeDeletedWMS1131_R01DetailList();
		removeSelectedWMS1131_R01DetailList();
		setEditWMS1131_R01({ ...defaultWMS1131_R01HeaderRow(), })
	}, [initData, defaultLabelPrintAuto, setWMS1131_R01Filter, removeDeletedWMS1131_R01DetailList, removeSelectedWMS1131_R01DetailList, setEditWMS1131_R01, defaultWMS1131_R01HeaderRow])

	const handleDeleteClick = useCallback(() => {

		if (deletedWMS1131_R01DetailList.length > 0) {
			// 삭제 표시된 행이 있으면 전체 복구
			removeDeletedWMS1131_R01DetailList(deletedWMS1131_R01DetailList);
			removeSelectedWMS1131_R01DetailList();
			setWMS1131_R01DetailList([...WMS1131_R01DetailList]);
		} else if (selectedWMS1131_R01DetailList.length > 0) {
			addDeletedWMS1131_R01DetailList(selectedWMS1131_R01DetailList);
			removeSelectedWMS1131_R01DetailList(selectedWMS1131_R01DetailList);
		}
	}, [selectedWMS1131_R01DetailList, 
		deletedWMS1131_R01DetailList,
		addDeletedWMS1131_R01DetailList,
		removeDeletedWMS1131_R01DetailList,
		removeSelectedWMS1131_R01DetailList,
		setWMS1131_R01DetailList,
		WMS1131_R01DetailList]);
	
	const handleCreateClick = async () => {
		setEditWMS1131_R01({ ...defaultWMS1131_R01HeaderRow(), })
		setSelectedWMS1131_R01(undefined);
		setDetailFetchTrigger(false);
		setWMS1131_R01DetailList([]);
		await insertWMS1131_R01DetailList([{...defaultWMS1131_R01DetailRow()}]);
		setDeletedWMS1131_R01DetailList([]);
		setSelectedWMS1131_R01DetailList([]);
		setOriginalWMS1131_R01DetailList([]);
	}

	const handleInsertClick = useCallback((e: React.MouseEvent, rowIndex?: number) => {
		const isGridInsert = rowIndex !== undefined;

		InsertRowHandler({
			event: e,
			dataList: WMS1131_R01DetailList,
			rowData: isGridInsert
				? WMS1131_R01DetailList[rowIndex]
				: { ...defaultWMS1131_R01DetailRow(), valueIndex: -1 },
			insertRow: insertWMS1131_R01DetailList,
			defaultRowData: defaultWMS1131_R01DetailRow(),
			...(isGridInsert && { setClickable }),
		});
	}, [WMS1131_R01DetailList, insertWMS1131_R01DetailList, defaultWMS1131_R01DetailRow, setClickable]);

	const validateInsertData = (header: WMS1131_R01HeaderDto, detailList: WMS1131_R01DetailDto[]) => {

		if (!validateString(header.compCd)) {
			showWarning('사업장을 선택해주세요.'); return false;
		}
		if (!validateString(header.customCd)) {
			showWarning('거래처를 입력해주세요.'); return false;
		}
		if (!validateCustomCd(header.customCd, customCdList)) {
			showWarning('거래처가 존재하지 않습니다.(입력칸을 더블클릭하거나 엔터키로 세부사항을 열어서 지정해주세요)'); return false;
		}
		if (!validateString(header.logicCenter)) {
			showWarning('물류센터를 선택해주세요.'); return false;
		}
		if (!validateString(header.warehouseCd)) {
			showWarning('창고번호를 선택해주세요.'); return false;
		}
		// if (!validateString(header.empNo)) {
		// 	showWarning('입고담당자를 선택해주세요.'); return false;
		// }
		// if (!validateEmployeeCd(header.empNo, employeeCdList)) {
		// 	showWarning('입고담당자가 존재하지 않습니다.(입력칸을 더블클릭하거나 엔터키로 세부사항을 열어서 지정해주세요)'); return false;
		// }
		if(!validateString(header.inoutMethod)) {
			showWarning('입고구분을 선택해주세요.'); return false;
		}

		if(detailList.length === 0) {
			showWarning('상세내역을 입력해주세요.'); return false;
		}
		for(const item of detailList) {
			if (deletedWMS1131_R01DetailList.includes(item.valueIndex.toString())) {
				continue;
			}
			if(!validateString(item.itemCd)) {
				showWarning('품목코드를 입력해주세요.'); return false;
			}
			if(!validateString(item.itemStatus)) {
				showWarning('품목의 상태를 선택해주세요.'); return false;
			}
			if(item.qty <= 0) {
				showWarning('수량을 입력해주세요.'); return false;
			}

			const activeDetailList = detailList.filter(detail =>
				!deletedWMS1131_R01DetailList.includes(detail.valueIndex.toString())
			);
			const otherDetailList = activeDetailList.filter((_, index) =>
				index !== activeDetailList.findIndex(d => d.itemCd === _.itemCd)
			);
			if (otherDetailList.some(otherDetail => otherDetail.itemCd === item.itemCd)) {
				showWarning("중복된 품목코드가 있습니다.\n품목코드: " + item.itemCd);
				return false;
			}
		}

		return true;
	}

	const setInfoDetailList = useCallback((header: WMS1131_R01HeaderDto, detailList: WMS1131_R01DetailDto[]) => {
		
		return detailList.map((value, idx) => ({
			...value,
			compCd: header.compCd,
			customCd: header.customCd,
		}))
	}, [setWMS1131_R01DetailList])


	const assignLotNoToMaps = useCallback(async (currentLotList: WMS1131_R01DetailDto[]) => {
		const newLotList = currentLotList.map(detail => ({ ...detail }));
		const promises: Promise<void>[] = [];

		for (const detail of newLotList) {
			if (!validateString(detail.lotNo)) {
				const promise = createWMS1131_R01LotNo().then((res) => {
						if (res.data && res.data.successFlag) {
							detail.lotNo = res.data.data;
						}
					});
					promises.push(promise);
				}
		}

		if (promises.length > 0) {
			await Promise.all(promises);
			setWMS1131_R01DetailList(newLotList);
		}

		return newLotList;
	}, [setWMS1131_R01DetailList]);
	
	const handleSaveClick = useCallback(async () => {

		setLoadingSpinner(true);

		let valid = true;
		if(!validateInsertData(editWMS1131_R01!, WMS1131_R01DetailList)) valid = false;      
		if(!valid) { setLoadingSpinner(false); return; }

		const isExistingTransport = validateString(editWMS1131_R01?.transportNo || '')
			&& WMS1131_R01List.some(row => row.transportNo === editWMS1131_R01?.transportNo);
		if (isExistingTransport) {
			showWarning('저장된 입고정보는 수정할 수 없습니다.  등록버튼을 눌러 신규 등록해주세요.');
			setMessage('저장된 입고정보는 수정할 수 없습니다.');
			setTimeout(() => setMessage(''), 3000);
			setLoadingSpinner(false);
			return;
		}

		setLoadingSpinner(true);
		
		const deletedWMS1131_R01DetailList_Number = deletedWMS1131_R01DetailList.map(value => Number(value));
		let processName = '';
		let newDetailList: WMS1131_R01DetailDto[] = [];
		let newHeaderList: WMS1131_R01HeaderDto[] = [];
		let responseData: WMS1131_R01Dto = {
			wmsTransportHeaderDto: editWMS1131_R01!,
			wmsTransportDetailDtoList: WMS1131_R01DetailList
		};

		// STEP 0: 초기화 전에 LOT 번호 가져와서 WMS1131_R01DetailList의 각 row에 추가
		// ========================================
		newDetailList = await assignLotNoToMaps(WMS1131_R01DetailList);
		// STEP 1: 초기화 전에 미출력 라벨 데이터 추출 - 자동출력 옵션 체크
		// ========================================
		let unprintedItemLabelData: ItemLabelPrintData[] = [];
		if (WMS1131_R01Filter.labelPrintAuto === 'Y') {
			const store = useWMS1131_R01Store.getState();
			unprintedItemLabelData = WMS1131_R01_extractUnprintedItemLabelData(
				store,
				deletedWMS1131_R01DetailList,
			);
		}

		try {
				const payload: WMS1131_R01Dto = {
					wmsTransportHeaderDto: editWMS1131_R01!,
					wmsTransportDetailDtoList: setInfoDetailList(editWMS1131_R01!, newDetailList)
				};

				processName = 'post';
				const postResponse = await postWMS1131_R01(payload);
				responseData = postResponse.data.data;
				

				if (postResponse.data.successFlag) {
					showSuccess('사급자재가 입고 되었습니다.');
					setMessage('사급자재가 입고 되었습니다.');
				}else{
					showWarning('사급자재 입고 후 서버로부터 올바른 데이터를 받지 못했습니다.');
					setLoadingSpinner(false);
					return;
				}
			
		} catch (error: any) {
			console.log('error :', error.response?.data?.message || error.message);
			showError(error.response?.data?.message || '사급자재 입고 작업 중 오류가 발생했습니다.');
			setLoadingSpinner(false);
			return;
		}

		if (processName === 'post') {
			newHeaderList = [
				...WMS1131_R01List,
				responseData.wmsTransportHeaderDto,
			] as WMS1131_R01HeaderDto[];
			setWMS1131_R01List(newHeaderList);
			setSelectedWMS1131_R01(responseData.wmsTransportHeaderDto);
		}
		

		// setSelectedWMS1131_R01(undefined);
		// setSelectedWMS1131_R01DetailList([]); // 저장 후 상세행 선택 상태 초기화
		setTimeout(() => {
			setMessage('');
		}, 5000)
		setLoadingSpinner(false);

		// 저장 후 미출력 품목 라벨 출력 (QZ 사용 시 QZ로, 미사용 시 브라우저 인쇄)
		if (
			WMS1131_R01Filter.labelPrintAuto === 'Y'
			&& unprintedItemLabelData.length > 0 && processName !== 'delete'
		) {
			try {
				const ok = await printBulkItemLabel(unprintedItemLabelData);
				if (ok) {
					showSuccess(`저장 완료! ${unprintedItemLabelData.length}개 라벨 출력`);
				} else {
					showWarning('저장은 완료되었으나 라벨 출력에 실패했습니다.  프린터 설정을 확인해주세요.');
					setLoadingSpinner(false);
				}
			} catch (error: unknown) {
				const message = error instanceof Error ? error.message : '알 수 없는 오류';
				console.error('품목 라벨 출력 실패:', error);
				showWarning(`저장은 완료되었으나 라벨 출력에 실패했습니다: ${message}`);
				setLoadingSpinner(false);
			}
		}
	}, [
		WMS1131_R01Filter,
		editWMS1131_R01,
		WMS1131_R01DetailList, deletedWMS1131_R01DetailList, setWMS1131_R01DetailList, handleCreateClick,
		printBulkItemLabel,
	]);

	
	const handleFetchDetailList = useCallback(async (transportNo: string, warehouseCd: string, isNewSelection: boolean) => {
		if (!warehouseCd) {
			showError('수불 정보의 물류정보의 조건에 맞는 창고 코드를 찾을 수 없어 입고 목록 내역을 조회할 수 없습니다.', 5000);
			setWMS1131_R01DetailList([]);
			return;
		}
		// 같은 행 재선택(조회→취소→재조회)에서도 상세는 다시 조회되어야 함.
		// 기존에는 isNewSelection=false 인 경우 조회가 스킵되어 DetailTable이 비는 문제가 있었음.
		// 이전에 선택한 입고정보와 현재 선택한 입고정보가 같으면 상세내역 검색 
        // 중단
        // if(!isNewSelection) return;

		try {
			const detailResponse = await getWMS1131_R01DetailList(transportNo, warehouseCd);
			const detailData = detailResponse.data.data;

			if (detailData && detailData.length > 0) {
				const currentDetailList = useWMS1131_R01Store.getState().WMS1131_R01DetailList;

				const existingItemsMap = new Map<string, WMS1131_R01DetailDto>();
				currentDetailList.forEach(item => {
					if (item.itemCd && item.itemStatus) {
						const key = `${item.itemCd}-${item.itemStatus}`;
						existingItemsMap.set(key, item);
					}
				});

				const updatedDetails = detailData.map((value) => {
					return {
						...value,
						valueIndex: value.valueIndex,
						orderIndex: value.orderIndex,
						orderIndexSeq: value.orderIndexSeq,
						cost: value.cost,
						amt: value.amt,
					}
				});
				setWMS1131_R01DetailList(updatedDetails);
				setOriginalWMS1131_R01DetailList(detailData);
				setMessage(`${selectedWMS1131_R01?.compNm}의 입고지시내역 ${detailData.length}건을 조회하였습니다.`);
				setTimeout(() => setMessage(""), 5000);

				// setSelectedWMS1131_R01DetailList([1 as any]);
			} else {
				showError('상세내역이 없습니다.');
				setWMS1131_R01DetailList([]);
			}
		} catch (error) {
			console.error("상세 내역 조회 실패:", error);
			showError('상세 내역을 조회하는 중 오류가 발생했습니다.');
			setWMS1131_R01DetailList([]);
		}
	}, [
		setMessage, 
		setWMS1131_R01DetailList,
		setOriginalWMS1131_R01DetailList,
		selectedWMS1131_R01?.compNm,
	]);
	
	const fetchAllDetailsForSelectedRow = useCallback(async () => {

		if (!selectedWMS1131_R01 || !selectedWMS1131_R01.transportNo) {
			if (!selectedWMS1131_R01) {
				setWMS1131_R01DetailList([]);
				setOriginalWMS1131_R01DetailList([]);
				setDetailFetchTrigger(false);
			}
			prevWmsOrderNoRef.current = undefined; // 이전 선택 초기화
			return;
		}

		// 이전에 선택한 입고정보와 현재 선택한 입고정보가 다른지 확인
		// 다르면 상세 내역 조회 시 입고량 초기화
		const previousOrderNo = prevWmsOrderNoRef.current;
		const currentOrderNo = selectedWMS1131_R01.transportNo;
		
		const isNewSelection = previousOrderNo !== currentOrderNo;
		
		// 1. 입고 정보 먼저 가져오기
		const headerData = await fetchOne();

		// 3. 현재 선택된 행과 API 데이터를 합쳐 기본값을 적용할 베이스 데이터를 만듭니다.
		const baseDataForDefaults = { ...defaultWMS1131_R01HeaderRow, ...headerData };
		
		//최종적으로 사용할 warehouseCd 결정
		const logicCenterToUse = baseDataForDefaults.logicCenter || '';
		const warehouseCdToUse = baseDataForDefaults.warehouseCd || '';

		// 4. 입고 헤더 정보 업데이트
		setEditWMS1131_R01({
			...defaultWMS1131_R01HeaderRow(),
			...headerData,					// 선택된 행의 정보가 베이스
			logicCenter: logicCenterToUse,
			warehouseCd: warehouseCdToUse,
		});
		
		// 5. 분리된 함수를 호출하여 상세 내역을 등록.
		handleFetchDetailList(selectedWMS1131_R01.transportNo, warehouseCdToUse, isNewSelection);
		prevWmsOrderNoRef.current = selectedWMS1131_R01.transportNo;

	}, [
		detailFetchTrigger,
		selectedWMS1131_R01,
		setWMS1131_R01DetailList,
		setOriginalWMS1131_R01DetailList,
		setDetailFetchTrigger,
		fetchOne,
		defaultWMS1131_R01HeaderRow,
		setEditWMS1131_R01,
		handleFetchDetailList
	]);

	//사급품 입고등록 상세조회 및 네비게이션 데이터 처리 통합
	useEffect(() => {
		const processDetail = async () => {
		const navData = PUR1021_WMS1131NavigationData ?? PUR1020_WMS1131NavigationData;
		// 1. 네비게이션 데이터가 있는 경우 (우선 처리)
		if (navData) {
			setPUR1021_WMS1131NavigationData(null);
			setPUR1020_WMS1131NavigationData(null);

			try{
				// 목록 갱신하되, 첫 번째 행 자동 선택 방지 (skipSelection = true)
				// await fetchData(true);

				// 그리드 선택 해제
				gridRef.current?.api?.deselectAll();

				// 전달받은 데이터로 폼 세팅
				setEditWMS1131_R01({ ...navData.wmsTransportHeaderDto });
				setWMS1131_R01DetailList(navData.wmsTransportDetailDtoList);
				setOriginalWMS1131_R01DetailList(navData.wmsTransportDetailDtoList);

				// 상태 초기화 및 상세조회 트리거 끄기
				useWMS1131_R01Store.setState({
					selectedWMS1131_R01: undefined,
					detailFetchTrigger: false,
					selectedWMS1131_R01DetailList: [],
					deletedWMS1131_R01DetailList: []
				});

			} catch (error) {
				console.error('사급품 입고등록 오류:', error);
				showError('사급품 입고등록 중 오류가 발생했습니다.');
			}

		} else{
			if (!detailFetchTrigger) return;
			fetchAllDetailsForSelectedRow();
			setDetailFetchTrigger(false);
			}
		};

		processDetail();
	}, [fetchAllDetailsForSelectedRow]);

	useEffect(() => {
		setWMS1131_R01Filter({ labelPrintAuto: defaultLabelPrintAuto });
	}, [defaultLabelPrintAuto, setWMS1131_R01Filter]);
	
	return {
		clickable, setClickable,
		handlePrintClick,
		handleExcelClick,
		fetchData,
		defaultWMS1131_R01HeaderRow,
		defaultWMS1131_R01DetailRow,
		initContainerData,
		handleDeleteClick,
		handleCreateClick,
		handleInsertClick,
		handleSaveClick,
	};
}
